import { connect } from 'react-redux';

import { IApplicationState } from 'shared/types/redux';

import { WorkplaceInCoworkingHeader } from '../WorkplaceInCoworkingHeader';
import { coworkingFlexibleWorkplaceCountSelector } from '../internal/selectors/coworkingFlexibleWorkplaceCountSelector';
import { coworkingFlexibleWorkplacePriceSelector } from '../internal/selectors/coworkingFlexibleWorkplacePriceSelector';
import { WorkplaceInCoworkingHeaderProps } from '../types';

export const FlexibleWorkplaceHeaderContainer = connect<WorkplaceInCoworkingHeaderProps, {}, {}, IApplicationState>(
  /**
   * @description Тестирование не требуется, так как селекторы и так затестированы
   */
  /* istanbul ignore next */
  state => ({
    count: coworkingFlexibleWorkplaceCountSelector(state),
    price: coworkingFlexibleWorkplacePriceSelector(state),
    title: 'Незакреплённое рабочее место',
  }),
  {},
)(WorkplaceInCoworkingHeader);
